import { Route, Routes, Navigate } from "react-router-dom"
import * as brands from "brands"
import * as layouts from "layouts"
import * as debugx from "x/debugx"
import * as routing from "./routing"
import * as bgtext from "brandguard/display/brandguard/text"
import * as bgimages from "brandguard/display/brandguard/images"
import * as bgdocuments from "brandguard/display/brandguard/documents"
import * as bgvideos from "brandguard/display/brandguard/videos"

export default function Routing(): JSX.Element {
	const brand = brands.caching.useCached()
	return (
		<layouts.backgrounds.Grey flex="0 1 100%" height="100%" overflowY="hidden">
			<Routes>
				<Route path="/image/score" element={<bgimages.Scoring />} />
				<Route path="/document/score" element={<bgdocuments.Scoring />} />
				<Route path="/text/score" element={<bgtext.Scoring />} />
				<Route path="/video/score" element={<bgvideos.Scoring />} />
				<Route path="/approval/image" element={<bgimages.approval.upload />} />
				<Route path="/approval/image/review" element={<bgimages.approval.review />} />
				<Route path="/approval/image/approved" element={<bgimages.approval.approved />} />
				<Route path="/approval/image/rejected" element={<bgimages.approval.rejected />} />
				<Route path="/approval/text" element={<bgtext.approval.upload />} />
				<Route path="/approval/text/review" element={<bgtext.approval.review />} />
				<Route path="/approval/text/approved" element={<bgtext.approval.approved />} />
				<Route path="/approval/text/rejected" element={<bgtext.approval.rejected />} />
				<Route path="/approval/document" element={<bgdocuments.approval.upload />} />
				<Route path="/approval/document/review" element={<bgdocuments.approval.review />} />
				<Route path="/approval/document/approved" element={<bgdocuments.approval.approved />} />
				<Route path="/approval/document/rejected" element={<bgdocuments.approval.rejected />} />
				<Route path="/approval/video" element={<bgvideos.approval.upload />} />
				<Route path="/approval/video/review" element={<bgvideos.approval.review />} />
				<Route path="/approval/video/approved" element={<bgvideos.approval.approved />} />
				<Route path="/approval/video/rejected" element={<bgvideos.approval.rejected />} />
				<Route
					path="/approval"
					element={
						<Navigate
							to={
								debugx.alpha.enabled()
									? routing.image.approval.upload(brand.id)
									: routing.image.approval.review(brand.id)
							}
							replace
						/>
					}
				/>
				<Route path="*" element={<Navigate to={routing.image.score(brand.id)} replace />} />
			</Routes>
		</layouts.backgrounds.Grey>
	)
}
